import datamethods from '../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../style/format.js'
export default{
    mixins:[datamethods,format],
    computed:{
      ...mapFields([
        'panels',
        'ticketType_Culinary',
        'ticketTypeList_Culinary',
        'tableList_Culinary',
        'tableNumber_Culinary',
        'guestName_Culinary',
        'employee_Culinary',
        'employeeList_Culinary',
        'prepAreas'
       

    ]),
    getGuestTotals(){
        //console.log('get guest totals')
        var lasthadtotal=true
        var guestTotals = []

        for (let i = 1; i <= 20; i++) {
          var n = "Guest " + i
          var t = this.getGuestTotal(n)
          
          var g1 = {
              name:n,
              total:t,
              show:lasthadtotal || i==1 || i==2
          }

          guestTotals.push(g1)
          lasthadtotal=t>0
        }
        
        return guestTotals
      },
      
    },
    methods:{
        
        selectTicketTypeCulinary(id,name){
            this.ticketType_Culinary=name
            this.tableNumber_Culinary=0
            this.guestName_Culinary=null
    
         },
         selectTable(id,name){
            this.tableNumber_Culinary=name
            this.panels[0].valid = true;
            this.panels[1].available = true;
            
            this.panels[0].title =  "Table " + this.tableNumber_Culinary + " " + this.employee_Culinary.name
            //this.panels[0].subtitle1="Server " + this.employee_Culinary.name
         },
         changeGuestName(){
            this.panels[0].valid = true;
            this.panels[1].available = true;
            
            this.panels[0].title =  "Take Out for Guest " + this.guestName_Culinary
            //this.panels[0].subtitle1="Guest " + this.guestName_Culinary
         },
         async getEmployeeList_Culinary(){
            let req = {
              ID:this.location.id
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'employee_culinary')
            //handle response
         
            if(response.Successful){
              this.employeeList_Culinary=response.ItemList
    
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
         },
         selectEmployeeCulinary(id,name){
            this.employee_Culinary={
              id:id,
              name:name
            }
         },
         async AddTicket_Culinary(){
            //if we already have a ticket (this came from reservation) - then just do the update part to add table and employee
            if(this.ticket.id>0){
              this.updateticket_culinary()

              return //don't add one
            }
         

            let req = {
              ticket:{
                guestId:null,
                businessDayId:this.businessDayId,
                locationId:this.location.id,
                terminalId:this.terminalId,
                employeeId:this.employee_Culinary.id,
                tableNumber:this.tableNumber_Culinary,
                takeoutGuestName:this.guestName_Culinary,
                isDineIn:this.ticketType_Culinary=='Dine In'

              }
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'addticket')
            //handle response
         
            if(response.Successful){
           
              this.ticket.id=response.ResponseInteger
              this.toNext();//
              this.$store.dispatch('startOver_Cart');
    
              this.$nextTick(() => {
                this.refreshticket(true)
              })
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          async updateticket_culinary(){
             let req = {
              ticket:{
                guestId:null,
                businessDayId:this.businessDayId,
                locationId:this.location.id,
                terminalId:this.terminalId,
                employeeId:this.employee_Culinary.id,
                tableNumber:this.tableNumber_Culinary,
                takeoutGuestName:this.guestName_Culinary,
                isDineIn:this.ticketType_Culinary=='Dine In',
                id:this.ticket.id
              }
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateticket_culinary')
            //handle response
         
            if(response.Successful){
           
              this.toNext();//
    
              this.$nextTick(() => {
                this.refreshticket()
              })
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          getGuestTotal(guestnumber){
            var total=0
            if(this.ticket.lineItems!=undefined){
              this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.guestNumber==guestnumber ){
                        total = total + li.amount + li.tax
                    }
                } 
            }
            
               // console.log('gtotal ' + total)
            return total.toFixed(2)
          },
          async UpdateLineItemGuestNumbers(){

         

            let req = {
              ticket:this.ticket
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateticketlineitem_guestnumber')
            //handle response
         
            if(response.Successful){
           
            
              this.$nextTick(() => {
                this.refreshticket(true)
              })
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          async sendtickettokitchen(gotopay=false,thispanelIndex){
            this.inPayment=true
            console.log('inpay=true sendtickettokitchen')
            let req = {
                ticket:this.ticket
              }
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'sendtickettokitchen')
              //handle response
          
              if(response.Successful){
                if(gotopay){
                  this.inPayment=false
                  var nextPanelIndex = Number(thispanelIndex) + 1;
                  this.$store.dispatch('setActivePanel',nextPanelIndex);
                }else{
                  this.inPayment=false
                  //start over
                  this.$store.dispatch('startOver');
                }
                
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
              this.inPayment=false
          },
          async GetPrepAreas(){

            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'prepareas')
            //handle response
         
            if(response.Successful){
           
              this.prepAreas=response.ProductPrepAreaList
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
    }

}

